// extracted by mini-css-extract-plugin
export default {"modal":"modal__UaeXB","content":"content__OHmwW","content__wrap":"content__wrap__pM9rv","content__checkbox":"content__checkbox__bdxPW","content__tabs":"content__tabs__icfYA"};